export { default } from './BrandsBlock';
